import React from 'react';
interface StrikeRowProps {
  label?: React.ReactNode;
  columns: number;
  gapPx: number;
  labelWidth: number;
  /** 0 — ничего не прожито, 1 — строка прожита полностью */
  fraction: number;
  thickness?: number;
  rowHeight?: number;
  children: React.ReactNode;
}

/**
 * Одна строка сетки: подпись слева, ячейки справа и одна непрерывная
 * линия зачёркивания, которая обрывается ровно на «сегодня».
 */
export function StrikeRow({
  label,
  columns,
  gapPx,
  labelWidth,
  fraction,
  thickness = 2,
  rowHeight,
  children
}: StrikeRowProps) {
  return <div className="relative flex items-center" style={rowHeight ? {
    height: rowHeight
  } : undefined} data-id="element-104" data-mp="1osn095e1mp4r">
      {labelWidth > 0 &&
    // flex + leading-none убирает строчный strut родителя, иначе подпись
    // съезжает вниз внутри своей строки и линия проходит выше центра текста
    <div className="flex shrink-0 items-center leading-none" style={{
      width: labelWidth
    }} data-id="element-105" data-mp="1a3qs78bzlc45">
          {label}
        </div>}
      <div className="relative grid flex-1 items-center" style={{
      gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
      columnGap: `${gapPx}px`
    }} data-id="element-106" data-mp="22td7z2dl0acd">
        {children}
      </div>
      {fraction > 0 && <div aria-hidden className="bg-ink pointer-events-none absolute left-0 top-1/2 -translate-y-1/2" style={{
      height: thickness,
      width: `calc(${labelWidth}px + ${fraction} * (100% - ${labelWidth}px))`
    }} data-id="element-107" data-mp="2ck7sa179ozv6" />}
    </div>;
}